/* @flow */

import React from 'react';
import { Message } from 'semantic-ui-react';

const View = () => (
  <Message
    icon="calendar"
    header="Agenda"
    content={`L'agenda est géré via le module dédié.`}
  />
);

export default View;



// WEBPACK FOOTER //
// ./src/modules/catalog/plugins/agenda/View.js